/**
 * Push Settings Page - Wrapper for PushSettingsPage component
 * Provides the full page layout for push notification settings
 */

import React from 'react';
import { PushSettingsPage as PushSettingsComponent } from '../components/PushSettingsPage';

export function PushSettingsPage() {
  return (
    <div className="push-settings-page-container">
      <h1>Push Notification Settings</h1>
      <PushSettingsComponent />
    </div>
  );
}
